var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRightBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 43,
    viewBox: "0 0 47 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.277344,
    y: 0.636719,
    width: 46,
    height: 42,
    rx: 12,
    fill: "#1552F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4325 22.8942H28.3354L22.6983 29.2878C22.2478 29.7988 22.2478 30.6373 22.6983 31.1482C23.1488 31.6592 23.8766 31.6592 24.3271 31.1482L31.9395 22.5143C32.39 22.0033 32.39 21.1779 31.9395 20.667L24.3386 12.0199C23.8881 11.509 23.1604 11.509 22.7099 12.0199C22.2594 12.5309 22.2594 13.3563 22.7099 13.8673L28.3354 20.2739H15.4325C14.7972 20.2739 14.2773 20.8635 14.2773 21.5841C14.2773 22.3047 14.7972 22.8942 15.4325 22.8942Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightBlue);
export default __webpack_public_path__ + "static/media/arrow-right-blue.9f26b8a7be9cdc54583720704818c229.svg";
export { ForwardRef as ReactComponent };